import { Wallet, Rocket, Bell, ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router";

export function ComingSoon() {
  const navigate = useNavigate();

  return (
    <div className="min-h-[80vh] flex flex-col items-center justify-center p-6 text-center animate-in fade-in duration-700">
      <div className="w-24 h-24 bg-[#0B6E4F]/10 rounded-[2rem] flex items-center justify-center mb-8 relative">
        <div className="absolute inset-0 bg-[#0B6E4F]/20 rounded-[2rem] animate-ping duration-[3000ms]" />
        <Wallet className="w-10 h-10 text-[#0B6E4F] relative z-10" />
      </div>

      <div className="space-y-4 max-w-sm mb-12">
        <h1 className="text-3xl font-black text-[#0D1A12] leading-tight tracking-tight">
          Wallet is Launching Soon!
        </h1>
        <p className="text-[#64748B] font-medium leading-relaxed">
          We're currently in final private beta testing. MoniFlow Wallet will be available to all sellers in production very shortly.
        </p>
      </div>

      <div className="grid grid-cols-2 gap-4 w-full max-w-sm mb-12">
        <div className="bg-white p-5 rounded-3xl border border-gray-100 shadow-sm flex flex-col items-center gap-2">
            <Rocket className="w-6 h-6 text-amber-500" />
            <span className="text-[10px] font-black text-[#0D1A12] uppercase tracking-widest">Early Access</span>
        </div>
        <div className="bg-white p-5 rounded-3xl border border-gray-100 shadow-sm flex flex-col items-center gap-2">
            <Bell className="w-6 h-6 text-blue-500" />
            <span className="text-[10px] font-black text-[#0D1A12] uppercase tracking-widest">get notified</span>
        </div>
      </div>

      <button 
        onClick={() => navigate('/seller')}
        className="flex items-center gap-2 text-[#64748B] font-bold text-sm hover:text-[#0D1A12] transition-colors"
      >
        <ChevronLeft className="w-4 h-4" />
        Back to Dashboard
      </button>
    </div>
  );
}
